import { EventTypes, VisibilityStates } from '@racemap/utilities/consts/events';
import { isGroupEvent } from '@racemap/utilities/functions/utils';
import type { RacemapEvent } from '@racemap/utilities/types/events';
import type { Immutable } from 'immer';
import type { DateTime } from 'luxon';

export type DuplicateEventPropsInput = {
  event: Immutable<RacemapEvent>;
  newEventName: string;
  newEventTimes: [DateTime, DateTime];
  copyToGroup: boolean;
};

export const buildDuplicateEventProps = ({
  event,
  newEventName,
  newEventTimes,
  copyToGroup,
}: DuplicateEventPropsInput): Partial<RacemapEvent> => {
  const [startTime, endTime] = newEventTimes;

  const newProps: Partial<RacemapEvent> = {
    startTime: startTime.toISO() || undefined,
    endTime: endTime.toISO() || undefined,
    name: newEventName,
    visibility: VisibilityStates.UNLISTED,
  };

  if (event.type === EventTypes.SAFEMAP) {
    newProps.type = EventTypes.SAFEMAP;
  } else if (!copyToGroup && !isGroupEvent(event)) {
    newProps.type = EventTypes.REGULAR;
    newProps.parent = null;
  }

  return newProps;
};
